// lib/api.js
const postRequest = async (url, data) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const loginUser = (url, idbg, pin, serverUrl) => {
  const data = {
    guiname: idbg,
    pincode: Object.values(pin).join(""),
    server_url: serverUrl,
  };
  return postRequest(`${url}/api/inerygui/login`, data);
};

export const checkDuplicateIDBG = (url, idbg, serverUrl) => {
  const data = { guiname: idbg, server_url: serverUrl };
  return postRequest(`${url}/api/inerygui/guiname_exists`, data);
};
